import React, { Component } from "react";
import { connect } from "react-redux";

class ThemeButton extends Component {
    constructor(props) {
        super(props);
        this.state = { disabled: !props.inCart };

        if(!props.inCart){
            setTimeout(() => this.setState({ disabled: false }), 500);
        }
    }

    onClick(e) {
        this.props.onClick(e);
    }

    render() {
        let { Customer, children, className = "", onClick, inCart, ...otherProps } = this.props;
        let colour = "#CF122F";

        if (Customer) colour = Customer.Colour;

        return (
            <button
                style={{ backgroundColor: colour }}
                onClick={onClick}
                className={"button " + className}
                disabled={this.state.disabled}
                {...otherProps}
            >
                {children}
            </button>
        );
    }
}

const mapStateToProps = state => {
    return {
        Customer: state.TradeCustomer
    };
};

export default connect(mapStateToProps, {})(ThemeButton);



// WEBPACK FOOTER //
// ./src/components/ThemeButton.js